import { LoadingButton } from '@mui/lab';
import * as React from 'react';

interface Props {
  disabled?: boolean;
  loading?: boolean;
  error?: string;
}

export const ContinueButton: React.FC<Props> = (props) => {
  const { disabled, loading, error } = props;
  return (
    <div className="w-full space-y-2">
      <LoadingButton
        type="submit"
        variant="contained"
        size="large"
        fullWidth
        disabled={disabled}
        loading={loading}
      >
        <h3>Continue</h3>
      </LoadingButton>
      {error && <div className="text-red-900">{error}</div>}
    </div>
  );
};
ContinueButton.displayName = 'CreateCompany.CompanyDetails.ContinueButton';
